import Vue from "vue";

Vue.component("wto-tag-input-string", {
	props: ["label", "placeholder", "allowNew", "errorMessage", "dataSource", "dataOutput", "maxTags"],
	data() {
		return {
			filteredItems: this.dataSource
		};
	},
	computed: {
		noData() {
			return window.labels.noData;
		},
		computedValue: {
			get() {
				let returnValue = [];
				if (this.dataOutput) {
					returnValue = this.dataOutput.split(",");
				}
				return returnValue;
			},
			set(selectedItem) {
				this.$emit("update:dataOutput", selectedItem.join(","));
			}
		}
	},
	methods: {
		getFilteredItems(text) {
			this.favoriteModel.filteredTagItems = this.favoriteModel.tagItems.filter((tag) => {
				return tag.toLowerCase().indexOf(text.toLowerCase()) >= 0;
			});
		},
		handleBlur() {
			const tagInput = this.$refs.tagInputFavorite;
			if (tagInput.newTag) {
				const isExist = tagInput.tags.filter((option) => {
					return option.toString().toLowerCase() === tagInput.newTag.toLowerCase();
				});

				if (isExist.length === 0) {
					tagInput.tags.push(tagInput.newTag);
					this.computedValue.push(tagInput.newTag);
				}
				tagInput.newTag = "";
			}
		},
		addItem: function (text) {
			if (typeof text === 'string' && text) {
				const tagInput = this.$refs.tagInputFavorite;
				const removeIndex = tagInput.tags.map(function (item) { return item.toLowerCase(); }).indexOf(text.toLowerCase());
				tagInput.tags.splice(removeIndex, 1);

				const isExist = tagInput.tags.filter((option) => {
					return option.toString().toLowerCase() === text.toLowerCase();
				});

				if (isExist.length === 0) {
					tagInput.tags.push(text);
				}
			}
		}
	},
	template: `
		<div class="column">
			<b-field :label="label" :type="errorMessage ? 'is-danger' : ''" :message="errorMessage">
				<b-taginput v-model="computedValue" 
				            ref="tagInputString" 
				            autocomplete 
				            icon="label" 
							:maxtags="maxTags"
				            :data="filteredItems" 
				            :allow-duplicates="false"
				            :open-on-focus="true"
				            :allow-new="true" 
				            :placeholder="placeholder"
				            @blur="handleBlur"
				            @add="addItem"
				            @typing="getFilteredItems">
					<template slot-scope="props">
						{{props.option}}
					</template>
					<template #empty>
						{{ noData }}
					</template>
					<template #selected="props">
						<b-tag v-for="(item, index) in props.selectTags" :key="index" rounded :tabstop="false" ellipsis closable @@close="$refs.tagInputString.removeTag(index, $event)">
							{{item}}
						</b-tag>
					</template>
				</b-taginput>							
			</b-field>
		</div>
	`
});